/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Palette_Load_Failed_HintInputs */



/**
* | output |
* | --- |
* | "Close this and try again." |
*
* @param {Palette_Load_Failed_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const palette_load_failed_hint = /** @type {((inputs?: Palette_Load_Failed_HintInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Palette_Load_Failed_HintInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Schließe das und versuche es erneut.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermez ceci et réessayez.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("关闭后重试。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("請關閉後再試一次。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("창을 닫고 다시 시도하세요.")
	return /** @type {LocalizedString} */ ("Close this and try again.")
});